// Keep bulk actions from saturating the API with one request per selected account.
export async function runBatch<T>(items: T[], action: (item: T) => Promise<{ ok: boolean }>) {
  let nextIndex = 0
  let succeeded = 0
  const failed: T[] = []
  async function run() {
    while (nextIndex < items.length) {
      const item = items[nextIndex++]
      try {
        const result = await action(item)
        if (result.ok) succeeded += 1
        else failed.push(item)
      } catch {
        failed.push(item)
      }
    }
  }
  await Promise.all(Array.from({ length: Math.min(4, items.length) }, run))
  return { succeeded, failed }
}
